import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { api } from "../lib/api";
import { SITE_URL, SITE_NAME } from "../lib/seo";

export function Seo({ path, title, description, jsonLd, image }) {
  const [override, setOverride] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/seo", { params: { path } })
      .then((res) => {
        if (!cancelled && res.data) setOverride(res.data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [path]);

  const finalTitle = override?.title || title;
  const finalDescription = override?.description || description;
  const canonical = `${SITE_URL}${path === "/" ? "" : path}`;
  const ogImage = image || `${SITE_URL}/kaveribiz_logo.png`;
  const jsonLdList = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={ogImage} />

      {jsonLdList.map((obj, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
}
